import { useAtom } from "jotai";

import { AdoptedMixAtom, useGlobalMMMStore } from "../mmm-provider";

export const useAdoptedMix = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [adoptedMixData, setAdoptedMixData] = useAtom(AdoptedMixAtom, {
    store: GlobalMMMStore,
  });

  return [adoptedMixData, setAdoptedMixData] as const;
};
